module.exports = __webpack_public_path__ + "static/media/logo-royal-caribbean.0551cc6a.png";